import "./style.css";
import Modal from "@/components/Modal";

export default class SubscriptionSuccessModal extends Modal {
  static selector = ".subscription-success-modal";

  constructor(block) {
    super(block);

    this.block = block;
  }

  // Lifecycle methods
  onReady() {
    this.open();
  }

  modalDidMount = async () => {};
  modalWillOpen = async () => {};

  modalDidUpdate = async () => {};
  modalDidClose = async () => {
    window.history.replaceState({}, document.title, "/profile");
  };

  onDestroy() {}
}
